import { render, staticRenderFns } from "./industry-chain.vue?vue&type=template&id=de84be36&scoped=true&"
import script from "./industry-chain.vue?vue&type=script&lang=js&"
export * from "./industry-chain.vue?vue&type=script&lang=js&"
import style0 from "./industry-chain.vue?vue&type=style&index=0&id=de84be36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de84be36",
  null
  
)

export default component.exports